/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type PlayersControllerListPlayersV1SortBy = typeof PlayersControllerListPlayersV1SortBy[keyof typeof PlayersControllerListPlayersV1SortBy];


export const PlayersControllerListPlayersV1SortBy = {
  recent: 'recent',
  name: 'name',
  age: 'age',
  marketValue: 'marketValue',
  weeklyWage: 'weeklyWage',
  contractUntil: 'contractUntil',
} as const;
